import React from 'react';
import { useSelector } from 'react-redux';

import Ticket from './ticketList/Ticket';

// helpers import
import { getAllActiveTickets, getAllWaitingTickets } from '../../../../store/helpers';

function TicketList() {
    const tickets = useSelector(state => state.tickets.tickets);

    // find tickets are currently being served
    const activeTickets = getAllActiveTickets(tickets);
    // get waiting tickets
    const allWaitingTickets = getAllWaitingTickets(tickets);

    return (
        <div className="usersListContainer">
            <div className="user-list-online">
                { activeTickets.map( (ticket, index) => <Ticket ticket={ticket} key={index} active={1} /> ) }
            </div>
            {
                allWaitingTickets.length > 0 
                ?   (
                        <div className="user-list-offline">
                            <div>
                                <h5>Customers in Queue</h5>
                                <div className="ticket-indicators">
                                    <div className="indicator-item">
                                        <div className="indicator-square" style={{ backgroundColor: 'var(--green)' }}></div>
                                        <span>My active customers</span>
                                    </div>
                                    <div className="indicator-item">
                                        <div className="indicator-square" style={{ backgroundColor: 'var(--blue)' }}></div>
                                        <span>My customers</span>
                                    </div>
                                    <div className="indicator-item">
                                        <div className="indicator-square" style={{ backgroundColor: 'var(--red)' }}></div>
                                        <span>Customers only I can serve</span>
                                    </div>
                                </div>
                                { allWaitingTickets.map( (ticket, index) => <Ticket ticket={ticket} key={index} active={0}  /> ) }
                            </div>
                        </div>
                    )
                    :   null
            }
        </div>
    );
}

export default TicketList;
